module["exports"] = [
  "#{Name.name}",
  "#{Company.name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/app/author.js
// module id = 256
// module chunks = 0